import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, collection, addDoc } from 'firebase/firestore';
import { useCart } from '../Context/CartContext';
import { getAuth } from 'firebase/auth';
import ReactMarkdown from 'react-markdown';
import '../css/ProductDetailPage.css';

// Feature Icons
import parabenFree from '../assets/images/paraben-free.png';
import sulphateFree from '../assets/images/sulphate-free.png';
import crueltyFree from '../assets/images/cruelty-free.png';
import non from '../assets/images/non-carc.png';
import siliconFree from '../assets/images/silicon-free.png';

import ShopPage from './ShopPage';

function ProductDetailPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [reviewText, setReviewText] = useState('');
  const [reviews, setReviews] = useState([]);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();
  const { addToCart, setShowCartModal } = useCart();
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);


const handleImageClick = (index) => {
  setSelectedImageIndex(index);
};

  // Fetch logged-in user
  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      setUserName(user.displayName || 'Anonymous');
    }
  }, []);

  // Fetch product from Firestore
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productDoc = await getDoc(doc(db, 'products', id));
        if (productDoc.exists()) {
          const fetchedProduct = productDoc.data();
          setProduct(fetchedProduct);
          setFaqs(fetchedProduct.faqs || []);

          setReviews(fetchedProduct.reviews || []);
        }
      } catch (err) {
        console.error('Error loading product:', err);
      }
    };

    fetchProduct();
  }, [id]);

  const handleAddToCart = () => {
    addToCart({ ...product, qty: 1 });
    setShowCartModal(true);
  };

  const handleBuyNow = () => {
    const productToBuy = { ...product, qty: 1 };
    navigate('/checkout', { state: { cartItems: [productToBuy] } });
  };

  const handleReviewChange = (e) => {
    setReviewText(e.target.value);
  };

  const handleSubmitReview = async () => {
    if (reviewText.trim() === '') {
      return alert('Please write a review before submitting.');
    }

    try {
      const reviewData = {
        text: reviewText,
        author: userName,
        date: new Date(),
        productId: id, // Optional: for reference in global reviews collection
      };

      // 1. Add to product's reviews array
      const productRef = doc(db, 'products', id);
      const productDoc = await getDoc(productRef);

      if (productDoc.exists()) {
        const productReviews = productDoc.data().reviews || [];

        await updateDoc(productRef, {
          reviews: [...productReviews, reviewData],
        });

        // 2. Also save to 'reviews' collection
        await addDoc(collection(db, 'reviews'), reviewData);

        setReviews([...productReviews, reviewData]);
        setReviewText('');
        setShowThankYouPopup(true);
        setTimeout(() => setShowThankYouPopup(false), 3000);
      }
    } catch (error) {
      console.error('Error submitting review:', error);
    }
  };

  const displayReviews = () => {
    return reviews.map((review, index) => (
      <div className="review-item" key={index}>
        <p>{review.text}</p>
        <p className="review-author">- {review.author}</p>
      </div>
    ));
  };

  if (!product) return <p>Loading...</p>;

  const features = [
    parabenFree,
    sulphateFree,
    crueltyFree,
    non,
    siliconFree,
  ];

  return (
    <div className="product-detail-page">
      <div className="product-detail-container">
      <div className="product-image-gallery">
  <img
    src={product.images?.[selectedImageIndex] || 'https://via.placeholder.com/300'}
    alt={product.name}
    className="main-product-image"
  />

{product.images?.length > 1 && (
  <div className="thumbnail-row">
    {product.images.map((img, idx) => {
      console.log(`Thumbnail ${idx}:`, img); // Debug log
      return (
        <img
          key={idx}
          src={img || 'https://via.placeholder.com/60'}
          alt={`thumb-${idx}`}
          className={`thumbnail-image ${selectedImageIndex === idx ? 'active' : ''}`}
          onClick={() => handleImageClick(idx)}
        />
      );
    })}
  </div>
)}

</div>

        <div className="product-details">
          <h3 className="product-title">{product.name}</h3>
          <p className="product-price">₹{product.price}</p>

          <div className="product-description">
            <ReactMarkdown>{product.description || 'No description available.'}</ReactMarkdown>
          </div>

          <div className="star-rating">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
            <i className="bi bi-star"></i>
          </div>

          <div className="product-actions">
            <button className="btn btn-dark add-to-cart-btn" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <button className="btn btn-danger buy-now-btn" onClick={handleBuyNow}>
              Buy Now
            </button>

            <div className="features-icons">
              {features.map((img, idx) => (
                <img src={img} key={idx} alt={`feature-${idx}`} className="feature-icon-img" />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="review-section">
        <h3>Write a Review</h3>
        <textarea
          className="review-form"
          placeholder="Write your review here..."
          value={reviewText}
          onChange={handleReviewChange}
          rows="4"
        ></textarea>
        <button onClick={handleSubmitReview}>Submit Review</button>

        <div className="review-list">{displayReviews()}</div>
        {faqs.length > 0 && (
  <div className="faq-section">
    <h3>FAQs</h3>
    <ul className="faq-list">
      {faqs.map((item, index) => (
        <li key={index}>
          <p><strong>Q:</strong> {item.question}</p>
          <p><strong>A:</strong> {item.answer}</p>
        </li>
      ))}
    </ul>
  </div>
)}

      </div>

      <ShopPage categoryTitle="Similar Products" />

      {showThankYouPopup && (
        <div className="thank-you-popup">
          <div className="thank-you-content">
            <p>Thank you for your review! 😊</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductDetailPage;
